import { Component, computed, inject, signal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';
import { ResolutionService } from '../../resolution.service';

@Component({
  selector: 'app-new-website-welcome',
  imports: [MatCheckboxModule, MatFormFieldModule],
  templateUrl: './new-website-welcome.component.html',
  styleUrl: './new-website-welcome.component.scss'
})
export class NewWebsiteWelcomeComponent {

  #router = inject(Router);
  #activeModal = inject(NgbActiveModal);
  #signalsStoreService = inject(SignalsStoreService);
  #resolutionService = inject(ResolutionService);

  avoidHoldUpMessage = signal(false);

  customerName = computed(() => this.#signalsStoreService.sessionSignal()?.accountInfo?.firstName || 'Customer');

  isMobile = computed(() => this.#resolutionService.isMobile());

  handleCheckboxChange(checked: boolean) {
    this.avoidHoldUpMessage.set(checked);
  }

  confirmModalButtonsAction(avoid: boolean) {
    if (!avoid) return this.goToShop(avoid);
    this.#activeModal.close({ avoid });
  }

  goToShop(avoid: boolean) {
    this.#router.navigate(['/shop']);
    this.#activeModal.close({ avoid });
    this.#signalsStoreService.showCartPreview.set(true);
  }
}
